module.exports = __webpack_public_path__ + "img/aufzugoModernizationBanner.1bd8e64.webp";